import { Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

export const ComponentSpinner = ({
  label = '',
  sx,
  className,
  size
}: {
  label?: string;
  sx?: object;
  className?: string;
  size?: number;
}) => {
  return (
    <div
      style={{ color: 'rgb(156 163 175)', ...sx }}
      className={className ?? 'flex w-full justify-center items-center p-1'}>
      {label && (
        <Typography
          sx={{ marginRight: '1rem' }}
          variant="h6">
          {label}
        </Typography>
      )}
      <CircularProgress
        size={size ?? 30}
        color="inherit"
      />
    </div>
  );
};
